import { ErrorHandler, Injectable } from '@angular/core';
import { ApplicationInsightsService } from './application-insights.service';

@Injectable()
export class ErrorHandlerService extends ErrorHandler {
  constructor(private myMonitoringService: ApplicationInsightsService) {
    super();
  }

  handleError(error: Error) {
    this.myMonitoringService.logError(error);
  }
}
